import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const SiteLogoThunk = createAsyncThunk(
	"SiteLogo/SiteLogoThunk",
	async (_, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`admin/site_logo`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
